import linkifyHtml from 'linkify-html'
import {FC, useMemo} from 'react'
import {makeStyles} from 'tss-react/mui'

const FormattedChatMessageText: FC<FormattedChatMessageTextProps> = ({
  className, shouldFormatLinks = true, text,
}) => {
  const {classes} = useStyles({})
  const formattedText = useMemo(() => {
    const formattedText = text
      ?.replace(/\*(.*?)\*/g, '<b>$1</b>')
      ?.replace(/_(.*?)_/g, '<i>$1</i>')
    return shouldFormatLinks ? linkifyHtml(
      formattedText ?? '', {rel: 'noreferrer', target: '_blank'}
    ) : formattedText
  }, [shouldFormatLinks, text])
  return (
    <span
      className={`${classes.root} ${className ?? ''}`}
      dangerouslySetInnerHTML={{__html: formattedText as string}}
    />
  )
}

const useStyles = makeStyles<any>()(theme => ({
  root: {
    '& a': {
      color: theme.palette.info.main,
    },
  },
}))

interface FormattedChatMessageTextProps {
  className?: string
  shouldFormatLinks?: boolean
  text: string | undefined
}

export default FormattedChatMessageText
